import React from 'react';
import PT from 'prop-types';
import cn from 'classnames';

const ToggleButton = ({ labelName, onToggleChange, toggleStatus, extractToggle, inversion, id }) => {
  if (extractToggle) {
    return (
      <div className={cn('toggle-button__item', { inversion: inversion })}>
        <input
          type="checkbox"
          id={id && `${'toggle-button__input'}-${id}`}
          name="toggleButton"
          onChange={(event) => onToggleChange(event.target.checked)}
          checked={toggleStatus}
        />
        <label htmlFor={`${'toggle-button__input'}-${id}`}></label>
      </div>
    );
  } else {
    return (
      <div className="toggle-button__block">
        <p>{labelName}</p>
        <div className={cn('toggle-button__item', { inversion: inversion })}>
          <input
            type="checkbox"
            id="toggle-button__input"
            name="toggleButton"
            onChange={(event) => onToggleChange(event.target.checked)}
            checked={toggleStatus}
          />
          <label htmlFor="toggle-button__input" data-testid="dayoff-toggle"></label>
        </div>
      </div>
    );
  }
};

ToggleButton.propTypes = {
  labelName: PT.string,
  toggleName: PT.string,
  onChange: PT.func,
  extractToggle: PT.bool,
  inversion: PT.bool,
};

export default ToggleButton;
